import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { RedactionavisComponent } from './redactionavis/redactionavis.component';
import { DndDirective } from './services/dnd.directive';
import { MatIconModule } from '@angular/material/icon';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
	declarations: [
		RedactionavisComponent, DndDirective
	],
	exports: [RedactionavisComponent],
	imports: [CommonModule, ReactiveFormsModule, SharedModule, MatIconModule, HttpClientModule, AngularEditorModule ],
})
export class FormADModule {}
